<template>
  <div class="Shenqing">
    <div class="cont-card">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="item.title"
                           :name="index"
                           v-for="(item,index) in faq"
                           :key="index">
          <div v-html="item.content"
               class="faq-detail"></div>
        </van-collapse-item>
        <div class="nomore">
          没有更多了
        </div>
      </van-collapse>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axiosApi from "../api/api.js";

export default {
  name: 'Faq',
  components: {
  },
  data () {
    return {
      activeNames: ['0'],
      faq: [{
        ft: '在什么情况下我的预订会失败？',
        fa: '以下两种情况可能导致宿舍预订失败：您所在的大学不提供校内宿舍；宿舍不足。'
      },
      {
        ft: '我可以住在校外吗？',
        fa: '这是许多中国大学所允许的。'
      },
      {
        ft: '我能让我的家人和我一起住在校园里吗？',
        fa: '这是某些中国大学允许的。'
      },
      {
        ft: '我在申请表中勾选了单人房，为什么会显示双人房预订？',
        fa: '由于数量不足，贵校无法满足所有学生的要求。如果您同意转房，助学将为您预订双人房，以保证您在校园内的住宿。'
      },
      {
        ft: '我到达时住宿费会调整吗？',
        fa: '助学及其他相关文件的信息均来自学校，仅供参考。注册期间可能会发生变更。'
      },
      {
        ft: '我可以在注册期前办理登机手续吗？',
        fa: '一些大学允许学生在注册日期之前来。'
      },
      {
        ft: '如果我错过了注册怎么办？',
        fa: '大学要求学生按时注册。如果你不准时，你应该立即与助学或你所在的大学联系，请求允许。否则，您将被视为放弃注册。'
      },
      {
        ft: '我没有预订住宿。如果我到达时没有房间，我该怎么办？',
        fa: '助学建议学生提前预订住宿。如果您到达后没有房间，请联系学校或助学寻求帮助。助学可以在校外找到住宿信息。'
      }
      ]
    }
  },
  mounted () {
    axiosApi(
      'news/2', {}, 'get'
    ).then((res) => {
      this.faq = res.data.data
    })
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 0;
  h2 {
    text-align: center;
  }
  h4 {
    margin: 0;
  }
  font-size: 28px;
  p {
    margin-bottom: 20px;
    text-indent: 2em;
  }
  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}
[class*="van-hairline"]::after {
  border: none;
}
.cont-card {
  padding: 20px 0;
}

.cont-card ::v-deep {
  .van-collapse-item__content {
    background-color: #f7f8fa;
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
.faq-detail {
  color: #464646;
}
</style>
